import { render, staticRenderFns } from "./uncombat_unknockout.vue?vue&type=template&id=2d7f3d36&scoped=true"
import script from "./uncombat_unknockout.vue?vue&type=script&lang=js"
export * from "./uncombat_unknockout.vue?vue&type=script&lang=js"
import style0 from "./uncombat_unknockout.vue?vue&type=style&index=0&id=2d7f3d36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7f3d36",
  null
  
)

export default component.exports